"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGridColumns = exports.useApproveRequest = void 0;
const contract_hooks_1 = require("@hooks/contracts/contract.hooks");
const data_loader_hooks_1 = require("@hooks/data-loader.hooks");
const button_1 = require("@shared-modules/components/button");
const expandable_grid_1 = require("@shared-modules/components/expandable-grid");
const object_1 = require("@utils/object");
const core_1 = require("@web3-react/core");
const react_1 = __importDefault(require("react"));
const react_2 = require("react");
const react_router_dom_1 = require("react-router-dom");
const useApproveRequest = () => {
    const commandExecutor = (0, contract_hooks_1.useDefaultContractCallback)("MCNFT", "grantRole");
    const { chainId } = (0, core_1.useWeb3React)();
    const nftContract = (0, contract_hooks_1.useContract)("MCNFT", chainId);
    const { data: role } = (0, data_loader_hooks_1.useDataLoader)(nftContract === null || nftContract === void 0 ? void 0 : nftContract.MINTER_ROLE, [nftContract], undefined);
    return (0, react_2.useCallback)((account) => __awaiter(void 0, void 0, void 0, function* () {
        if (!role) {
            return;
        }
        const summary = `Approved account ${account}`;
        const promiseCallback = yield commandExecutor(summary, [role, account]);
        yield promiseCallback();
    }), [role, commandExecutor]);
};
exports.useApproveRequest = useApproveRequest;
const getGridColumns = (approveRequestHandler, rejectRequestHandler) => [
    {
        id: "wallet",
        title: "Wallet",
        size: 1,
        type: expandable_grid_1.ItemTypes.String,
        render: ({ wallet }) => (react_1.default.createElement("span", { className: "p-admin__address", title: wallet }, (0, object_1.formatAddress)(wallet))),
    },
    {
        id: "first",
        title: "First name",
        size: 1,
        type: expandable_grid_1.ItemTypes.String,
        render: ({ firstName }) => firstName || "-",
    },
    {
        id: "last",
        title: "Last name",
        size: 1,
        type: expandable_grid_1.ItemTypes.String,
        render: ({ lastName }) => lastName || "-",
    },
    {
        id: "profile",
        title: "",
        size: 1,
        type: expandable_grid_1.ItemTypes.String,
        render: ({ wallet }) => (react_1.default.createElement(react_router_dom_1.Link, { className: "g-link", target: "_blank", rel: "noreferrer", to: `/profile/${wallet}` }, "Open profile")),
    },
    {
        id: "controls",
        title: "",
        size: 1,
        type: expandable_grid_1.ItemTypes.String,
        render: ({ wallet }) => (react_1.default.createElement("div", { className: "p-admin__controls" },
            react_1.default.createElement(button_1.Button, { size: "small", onClick: () => approveRequestHandler(wallet), type: "primary" }, "Approve"),
            react_1.default.createElement(button_1.Button, { size: "small", onClick: () => rejectRequestHandler(wallet), type: "warning" }, "Decline"))),
    },
];
exports.getGridColumns = getGridColumns;
